import Modal from 'react-modal';
import './ConfirmModal.css';
import CloseIcon from './CloseIcon';

type ConfirmModalProps = {
  isOpen: boolean;
  onRequestClose: () => void;
  onConfirm: () => void;
  message: string;
  title?: string;
  loading?: boolean;
};

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onRequestClose,
  onConfirm,
  message,
  title,
  loading,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="modal-confirm-content"
      overlayClassName="modal-overlay"
    >
      <div className="modal-confirm-container">
        <div className="modal-confirm-header-panel">
          <span className="modal-confirm-panel-title">{title}</span>
          <button onClick={onRequestClose}>
            <CloseIcon />
          </button>
        </div>
        <p className="modal-message">{message}</p>
      </div>
      <div className="modal-button-group">
        {loading ? (
          <>Deletando Imagem...</>
        ) : (
          <>
            <button className="modal-button confirm" onClick={onConfirm}>
              Sim
            </button>
            <button className="modal-button cancel" onClick={onRequestClose}>
              Não
            </button>
          </>
        )}
      </div>
    </Modal>
  );
};

export default ConfirmModal;
